import * as React from "react";
import {ColumnType} from "../list/list/ColumnType";
import {Entry, ListEntriesRequest, ListTransactionsRequest, TransactionSearchType} from "../../http/protocol";
import {PagerModel} from "../list/list/PagerModel";
import {ListUtils} from "../list/list/ListUtils";
import {EntityDataTable} from "../list/list/EntityDataTable";
import { WalletService } from "../../services/WalletService";



let columns = [
    { property : "id", name : "Transaction ID", orderBy : "transactionId", type : ColumnType.LINK, getUrl : (item : Entry) => { return "/transaction/" + item.id} },
    { property : "timestamp", name : "Date", type : ColumnType.DATE},
    {
        property: "bonus", name: "Bonus ID",
        renderer: (property: string, name: string, item: any) => {
                return <span>{item["attributes"]["bonusId"]}</span>
        }
    },       
    { property : "comment", name : "Comment"},
    {
        property: "amount", name: "Amount",
        renderer: (property: string, name: string, item: any) => {
                return <span>{item["entries"][0]["amount"]["amount"]}</span>
        }
    },   
    {
        property: "currency", name: "Currency",
        renderer: (property: string, name: string, item: any) => {
                return <span>{item["entries"][0]["amount"]["currencyCode"]}</span>
        }
    },    
];

interface Props { bonusId : number, service : WalletService}

export class UserBonusEntriesList extends React.Component<Props,{ pager? : any, listRequest? : ListTransactionsRequest}> {

    constructor(props : Props) {
        super(props);
        this.state = { listRequest : {  
        'type': TransactionSearchType.ATTRIBUTE,
        'key': "bonusId",
        'value': props.bonusId.toString(),
        'limit' : 20, 'offset' : 0, 'orderBy' : "id", 'ascending' : false} };
    }
    
    pagerChanged(pager : PagerModel) {
        if(!this.state.listRequest) {
            return;
        }
        pager.ascending = false;
        let listRequest = ListUtils.toListRequest<ListEntriesRequest>(this.state.listRequest,pager);
        this.setState({listRequest : listRequest});
    }

    loadTransactions(request: ListTransactionsRequest){
        return this.props.service.getTransactionList(request);
    }    

  

    render() {
        if(!this.state.listRequest) {
            return <span/>
        }

        return <EntityDataTable
            columns={columns}
            service={this.props.service}
            listRequest={this.state.listRequest}
            onPagerChange={this.pagerChanged.bind(this)}
            onAction={()=>undefined}
            customRequest={this.loadTransactions.bind(this)}

        />
    }

}